import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.3334 5.00004C18.3334 4.08337 17.5834 3.33337 16.6667 3.33337H3.33341C2.41675 3.33337 1.66675 4.08337 1.66675 5.00004M18.3334 5.00004V15C18.3334 15.9167 17.5834 16.6667 16.6667 16.6667H3.33341C2.41675 16.6667 1.66675 15.9167 1.66675 15V5.00004M18.3334 5.00004L10.0001 10.8334L1.66675 5.00004",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMail;
